<template>
    <van-row>
        <van-col span="16" style="padding-right: 5px">
            <van-field
                    style="border-radius:3px; padding: 0px 0px 0px 10px; box-shadow: 0px 0px 3px #999999 inset"
                    v-model="child_name_model"
                    placeholder="代理名称"
                    clearable
            >
                <div slot="button">
                    <van-button  type="info" size="small" @click="searchWithChildName">搜索</van-button>
                </div>

            </van-field>
        </van-col>
        <van-col span="8" style="padding-left: 5px">
            <van-button  type="info" size="small" style="width: 100%" @click="showAll">展示全部</van-button>
        </van-col>
    </van-row>
</template>

<script>
    export default {
        name: "Wp_my_child_search",

        props:{
            childType:{type:String, default:""}
        },
        data(){
            return{
                child_name_model: "",
            }
        },

        // watch:{
        //     childName(newValue){
        //         this.child_name_model = newValue;
        //     }
        // },

        methods:{
            searchWithChildName(){
                if(this.child_name_model){
                    this.$emit("clickToSearch", this.child_name_model);
                }
            },

            showAll(){
                this.child_name_model = "";
                this.$emit("clickToShowAll");
            }
        }
    }
</script>

<style scoped>

</style>